import { FC } from 'react'
import { LucideProps } from 'lucide-react'

export enum FieldType {
  INPUT = 'Input',
  SELECT = 'Select',
  TEXTAREA = 'Textarea',
}

export enum ServiceType {
  GENERAL_MAINTENANCE = 'General Maintenance',
  BODYWORK = 'Bodywork',
  TIRE_SHOP = 'Tire Shop',
}

export type FormDataContact = {
  serviceType: ServiceType
  contactName: string
  phoneNumber: string
  address: string
  additionalNotes: string
  isFavorite: boolean
}

export type Option = {
  value: ServiceType
  label: string
}

export type Validation = {
  required?: string
  pattern?: {
    value: RegExp
    message: string
  }
}

export type Field = {
  id: keyof FormDataContact
  label: string
  placeholder: string
  type: FieldType
  options?: Option[]
  validation?: Validation
  icon?: FC<LucideProps>
}
